import uniq from 'lodash/uniq';

export default (tags, tagsToReplace) => {
  if (!tagsToReplace || tagsToReplace.length === 0) {
    return tags;
  }

  const replacedTags = tags.reduce((allTags, currentTag) => {
    const [key] = currentTag.split(':');
    const newTagValue = tagsToReplace.find((tag) => tag.startsWith(`${key}:`));
    if (newTagValue) {
      return [...allTags, newTagValue];
    }
    return [...allTags, currentTag];
  }, []);

  const newTags = tagsToReplace.filter(
    (tag) => !replacedTags.some((t) => t.startsWith(`${tag}:`)),
  );

  return uniq([...replacedTags, ...newTags]);
};



// WEBPACK FOOTER //
// ./src/providers/utils/get-unique-tags-by-key.js